import { Plural, Trans } from "@lingui/react/macro";
import React from "react";
import {
  Icon,
  PartialSanityImageType,
  SanityImage
} from "@silversea-ssc/ui-components-react";
import * as styles from "./WebQuoteModalContentWithImage.module.scss";
import CruiseDepartureArrivalDates from "components/cruises/CruiseDepartureArrivalDates";

type Props = {
  departureDate?: string;
  arrivalDate?: string;
  duration?: number;
  shipName?: string;
  cruiseName: string;
  cruiseCode: string;
  image?: PartialSanityImageType;
};

const WebQuoteModalContentWithImage: React.FC<
  React.PropsWithChildren<Props>
> = ({
  children,
  departureDate,
  arrivalDate,
  duration,
  shipName,
  cruiseName,
  cruiseCode,
  image
}) => {
  return (
    <>
      <div className={styles.background}>
        {image && <SanityImage image={image} className={styles.image} />}
        <div className={styles.content}>
          <div className={styles.title}>{cruiseName}</div>
          <div className={styles.dates} suppressHydrationWarning>
            <CruiseDepartureArrivalDates
              departureDate={departureDate}
              arrivalDate={arrivalDate}
            />{" "}
            • <Plural value={duration || 0} one="# Day" other="# Days" />
          </div>

          <div className={styles.context}>
            <div className={styles.ship}>
              <Icon name="ship" padding={"inline-right"} /> {shipName} |{" "}
              <Trans>Voyage number #{cruiseCode}</Trans>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.boxWrapper}>{children}</div>
    </>
  );
};

export default WebQuoteModalContentWithImage;
